<template>
  <div class="container medi-mass-frame medi-mass-top">

    <a href="https://logbox.co.za/#/providers">
      <img src="~assets/images/medi-mass/medi-mass-header.jpg" alt="" class="img-responsive">
    </a>

    <section class="section-2" v-once>

      <div class="row">
        <div class="col-sm-3">
          <img src="~assets/images/medi-mass/screenLeft.jpg" class="img-responsive">
        </div>
        <div class="col-sm-5 text-center line-seperator">
          <img src="~assets/images/medi-mass/screen.jpg" alt="" >
          <p class="lead">LogBox is an easy to use mobile and web app which allows your patients to capture their personal information once and share it electronically with your practice.</p>

        </div>
        <div class="col-sm-4">
          <h2>LogBox is integrated with Elixir </h2>
          <p class="lead">
            You don't have to worry about retyping patient information into your billing system. LogBox is integrated with Elixir so accurate information will flow from LogBox to invoicing in one easy click. It&#39;s that simple.</p>
          <img src="~assets/images/medi-mass/elex-logbox.jpg" class="img-responsive center-block" alt="">

        </div>
      </div>
    </section>

    <section class="section-3" v-once>
      <div class="row">

        <div class="col-sm-1"></div>
        <div class="col-sm-10">
          <ul>
            <li><span class="bolder">Send appointment details </span>via SMS or Email</li>
            <li>Patients <span class="bolder">connect to your practice</span> via the <span class="bolder">website</span> or mobile <span class="bolder">app</span></li>
            <li>Don't struggle to read bad handwriting, let the <span class="bolder">patient fill in their information</span> for you</li>
            <li><span class="bolder">Practice-specific Terms and Conditions </span> are sent to patients <span class="bolder">electronically</span></li>
            <li>Create your own <span class="bolder">customised questionnaires</span> using the LogBox form creator</li>
            <li><span class="bolder">Reduce bad debt</span> with <span class="bolder">accurate</span> patient information </li>
            <li>Receive <span class="bolder">live updates</span> if patient details change</li>
            <li><span class="bolder">POPI compliant</span></li>
          </ul>

        </div>
        <div class="col-sm-1"></div>

      </div>
    </section>
    <section class="section-4" v-once>
      <div class="row">
        <div class="col-sm-12">
          <h1>Patients are frustrated with filling in the same forms over and over again at different healthcare professionals.</h1>
          <h1>Join the LogBox community and move your practice into the digital age. </h1>
          <h1><span class="bolder">From LogBox to Elixir in seconds</span> - you will never want to transcribe a paper form again!</h1>

        </div>
      </div>
    </section>

    <section class="section-5">
      <div class="row">
        <div class="col-sm-12">
          <h1><span class="bolder">Contact</span> LogBox</h1>

          <h2>We know you're busy, so let us help you. Put your contact details in the fields below and we'll get back to you with all the information you need.
				</h2>
        </div>
      </div>

      <div class="well">
        <error-display v-if="errorMessage">{{errorMessage}}</error-display>

        <form name="contactMeForm" @submit.prevent="sendContactRequest">
          <div class="row">
            <div class="col-xs-9">
              <div class="row">
                <input-text name="name" label="First Name" class="col-xs-3" v-model="contactMeCriteria.name" :validation="$v.contactMeCriteria.name"></input-text>
                <input-text name="lastname" label="Last Name" class="col-xs-3" v-model="contactMeCriteria.lastName" :validation="$v.contactMeCriteria.lastName"></input-text>
                <input-text name="email" label="Email" class="col-xs-3" v-model="contactMeCriteria.email" :validation="$v.contactMeCriteria.email"></input-text>
                <input-text name="phone" label="Phone no." class="col-xs-3" v-model="contactMeCriteria.phoneNumber" :validation="$v.contactMeCriteria.phoneNumber"></input-text>
              </div>
            </div>
            <div class="col-xs-3">
              <button type="submit" id="contactMeSubmit" class="form-control form-btn btn-danger col-xs-12" :disabled="loading || contactRequestSent">
                  <span v-if="!loading">
                    {{contactMeButtonTitle}}
                  </span>
                <span v-else>
                    <i class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></i>
                    <span class="sr-only">Loading...</span>
                  </span>
              </button>
            </div>
          </div>
        </form>
      </div>

      <div class="clear"></div>

      <p class="lead">Prefer to contact us? Just send an email on <a href="mailto:contact@logbox.co.za">contact@logbox.co.za</a> or call us on <a href="tel:+27822627238">082 262 7238</a></p>
    </section>
    <a href="https://logbox.co.za/#/providers">
      <img src="~assets/images/medi-mass/medi-mass-footer.jpg" alt="" class="img-responsive">
    </a>
  </div>
</template>

<script>
  import { required, email } from 'vuelidate/lib/validators';
  import { phoneNumber, alphaWhite } from 'utils/validators';

  import InputText from 'components/common/inputs/InputText';
  import ErrorDisplay from 'components/common/outputs/ErrorDisplay';

  export default {
    name: 'med-e-mass',
    components: {
      InputText,
      ErrorDisplay,
    },
    data: () => ({
      loading: false,
      errorMessage: '',
      contactMeCriteria: {
        origin: 'med-e-mass-brochure',
        name: '',
        lastName: '',
        email: '',
        phoneNumber: '',
      },
      contactRequestSent: false,
      contactMeButtonTitle: 'Contact Me',
    }),
    validations: {
      contactMeCriteria: {
        name: {
          required,
          alphaWhite,
        },
        lastName: {
          required,
          alphaWhite,
        },
        email: {
          required,
          email,
        },
        phoneNumber: {
          required,
          phoneNumber,
        },
      },
    },
    methods: {
      async sendContactRequest() {
        this.$v.$touch();

        if (this.$v.$invalid) {
          this.errorMessage = 'Please ensure that your contact details are entered correctly.';
        } else {
          try {
            this.loading = true;
            await this.$api.sendContactRequest();

            this.contactRequestSent = true;
            this.contactMeButtonTitle = 'Request Sent';
          } catch (error) {
            this.errorMessage = this.$api.processError(error);
          } finally {
            this.loading = false;
          }
        }
      },
    },
  };

</script>

<style scoped>
  .medi-mass-top {
    margin-top: -60px
  }
  body, .container {
    padding: 0 !important;
  }
  #main-view, .container {
    max-width: 1140px;
  }
</style>



// WEBPACK FOOTER //
// MedEMass.vue?0eab2b46